"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.getStatusSuperior = getStatusSuperior;
exports.getStatuss = getStatuss;

require("core-js/modules/es6.array.of");

var _request = _interopRequireDefault(require("@/utils/request"));

function getStatuss(params) {
  return (0, _request.default)({
    url: 'api/status',
    method: 'get',
    params: params
  });
}

function getStatusSuperior(ids) {
  var data = ids.length || ids.length === 0 ? ids : Array.of(ids);
  return (0, _request.default)({
    url: 'api/status/superior',
    method: 'post',
    data: data
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/status',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/status',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/status',
    method: 'put',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  getStatuss: getStatuss,
  getStatusSuperior: getStatusSuperior
};
exports.default = _default;